export default {
  add: {
    method: 'post',
    url: '/admincp/node/location'
  },
  list: {
    method: 'post',
    url: '/admincp/node/location/list'
  },
  detail: {
    method: 'get',
    url: '/admincp/node/location/ID'
  },
  delete: {
    method: 'delete',
    url: '/admincp/node/location'
  },
  archive: {
    method: 'delete',
    url: '/admincp/node/location/archive'
  },
  restore: {
    method: 'put',
    url: '/admincp/node/location/restore'
  },
  getAll: {
    method: 'get',
    url: '/admincp/node/location/get-all'
  },
  find: {
    method: 'get',
    url: '/admincp/node/location/finds?key=KEY'
  }
}
